<script>
import NtvText from '../Text';
import NtvIcon from '../Icon';
import NtvTooltip from '../Tooltip';

/**
 * The shared label component between all input fields. Provides a
 * to display an info message tooltip and a required icon. All text
 * properties can be applied to NtvLabel through the use of
 * `v-bind="$attrs"`.
 */
export default {
  name: 'NtvLabel',

  directives: {
    tooltip: NtvTooltip.VTooltip
  },

  components: {
    NtvText,
    NtvIcon
  },

  props: {
    /**
     * The text to display in the label.
     */
    label: {
      type: [String, Number],
      default: ''
    },
    /**
     * The info message to be displayed in a tooltip.
     */
    infoMessage: {
      type: [String, Array],
      default: ''
    },
    /**
     * Flag to display the asterisk.
     */
    isRequired: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<template>
  <div
    class="ntv-label flex leading-none items-center"
    v-if="label || $slots.default"
  >
    <ntv-text
      class="flex items-center"
      v-bind="$attrs"
      :weight="$attrs.weight || 'medium'"
    >
      {{ label }}
      <slot />
      <div
        class="ntv-label__info ml-md"
        v-tooltip="{
          content: infoMessage,
          boundariesElement: '.ntv-label'
        }"
        v-if="infoMessage"
      >
        <ntv-icon
          use-fa
          name="infoCircle"
          color="grey"
          fixed-width
          size="sm"
        />
      </div>
      <div
        class="flex items-center ntv-label__required ml-md"
        v-if="isRequired"
      >
        <ntv-icon
          use-fa
          name="asterisk"
          color="danger"
          type="regular"
          fixed-width
          size="xs"
        />
      </div>
    </ntv-text>
  </div>
</template>
